import React from 'react'
import { Button } from 'semantic-ui-react'
import { MainArticleLayout } from '../../../layouts/MainArticleLayout'


const EnquiryAbandon = () => {


  const abandonEnquiry = () => {
    window.location.href = '/my-account/enquiry/submit-a-new-enquiry'
  }
  const returnEnquiriesPage = () => {
    window.location.href = '/my-account/enquiries'
  }

  return (
    <>
      <MainArticleLayout>
        <h2> Confirmation: Abandon enquiry </h2>
        <hr />
        <p></p>
        <p>
          Are you sure you want to abandon your enquiry?
        </p>
        <p></p>

        <p></p>
        Click &apos;Confirm&apos; to abandon your enquiry, click &apos;Cancel&apos; to return to enquiries page.
        <p></p>
        <p></p>
        <p></p>

        <Button className="ui is-secondary button" onClick={abandonEnquiry} q>
          Cancel
        </Button>
        <Button
          className="ui is-secondary button"
          onClick={returnEnquiriesPage}
        >
          Confirm
        </Button>
      </MainArticleLayout>
    </>
  )
}
export default EnquiryAbandon
